import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CreditCard, CreditCardValidators } from 'angular-cc-library';
import { defer, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService, UtilityService } from 'src/app/services';

@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.scss']
})
export class CreditCardComponent implements OnInit {
  CREDITCARD!: FormGroup;
  @Input() item: any;
  type$!: Observable<string>;
  credit_card_type = new FormControl ('');
  month = this.data.getMonth;
  expYears: number[] = this.util.getNextNyears(new Date(), 20);
  constructor(private fb: FormBuilder, private data: DataService, private util: UtilityService) { }

  ngOnInit(): void {
    // console.log('Initial item credit-card:', this.item);
    this.CREDITCARD = this.fb.group({
      credit_card_number: new FormControl('', [Validators.required, CreditCardValidators.validateCCNumber]),
      credit_card_type: this.credit_card_type,
      credit_card_exp_month: new FormControl('', Validators.required),
      credit_card_exp_year: new FormControl('', Validators.required),
      credit_card_cvv: new FormControl('', Validators.required),
      credit_card_holder_name: new FormControl('', Validators.required),
    });
    
    this.type$ = this.credit_card_number.valueChanges.pipe(
      map((num: string) => CreditCard.cardType(num))
    );
  }

  get credit_card_number(): FormControl {
    return this.CREDITCARD.get('credit_card_number') as FormControl;
  }

  getCREDITCARDFormValue(): any {
    if (this.CREDITCARD.invalid) {
      this.CREDITCARD.markAllAsTouched();
      return null;
    }
    return this.CREDITCARD.value;
  }
}
